import { formatNumber } from '@progress/kendo-intl';

const generateAxisChart = (setCategories, setValueAxis, setSeries, widgetData, setup, measures, chartData, selectedPeriod, periods, setGridData, forLocalCurrency) => {
  let _categoryMap = {};
  let periodIdField = 'id';
  let gridDataLocal = [];

  //SINGLE & MULTI PERIOD
  const _clearEmptySeries = (series) => {
    for (let i = series.length - 1; i > -1; i--) {
      if (series[i].data.length === 0) series.splice(i, 1);
    }
  };

  // SINGLE & MULTI PERIOD
  const hasMultipleValueAxes = () => {
    return setup.valueAxes.length > 1;
  };

  //SINGLE & MULTI PERIOD
  const _seriesBaseOptions = (series) => {
    let _hasStack = false;
    if (
      setup.series.find(function(item) {
        return item.stacked;
      })
    )
      _hasStack = true;

    let stack = _hasStack ? series.name : undefined;
    if (series.stacked) stack = series.stackGroup ? series.stackGroup : true;

    let options = {
      name: series.name,
      type: series.type || setup.type,
      axis: series.axis ? series.axis : undefined,
      stack: stack,
      data: [],
      lookupRef: {},
      field: 'data',
      line: {
        style: 'smooth',
      },
      markers: {},
      labels: {
        visible: setup.seriesLabels,
        background: 'transparent',
        position: 'outsideEnd',
        callbackTemplate: (e) => {
          return (
            e.dataItem && formatNumber(e.dataItem.amount, e.dataItem.lookupRef.percentage ? 'p' + e.dataItem.lookupRef.scale : 'n' + e.dataItem.lookupRef.scale)
          );
        },
      },
      legend: {
        visible: setup.legend !== 'none',
        position: setup.legend,
      },
      tooltip: {
        visible: true,
        callbackTemplate: (e) => {

          if (e.point) {
            return (
              e.point.category +
              ' ' +

              e.point.series.name +
              ': ' +
              formatNumber(
                e.point.value,
                e.point.dataItem.lookupRef.percentage ? 'p' + e.point.dataItem.lookupRef.scale : 'n' + e.point.dataItem.lookupRef.scale,
              )
            );
          }
        },
      },
      opacity: undefined,
    };

    if (options.type === 'marker') {
      options.type = 'line';
      options.opacity = 0;
      options.markers = {
        type: 'circle',
        size: 10,
        border: {
          width: 3,
        },
      };
    }

    return options;
  };

  //SINGLE & MULTI PERIOD
  const _registerGridRecord = (val, periodHash, amount) => {
    let gridVal = periodHash[val.periodId];

    if (!gridVal) {
      gridVal = { periodId: val.periodId, periodName: val.periodName, endDate: val.endDate };
      periodHash[val.periodId] = gridVal;
      gridDataLocal.push(gridVal);
    }
    gridVal['_' + val.nodeId + '_' + val.measureId] = amount;
    setGridData(gridDataLocal);
  };

  // SINGLE & MULTI PERIOD
  const _generateValueAxes = (valueAxes) => {
    let axes = [];
    for (let i = 0; i < valueAxes.length; i++) {
      let axis = valueAxes[i];

      axes.push({
        name: axis.id,
        axisCrossingValue: hasMultipleValueAxes() ? -100000000000000 : [0, -100000000000000],
        title: {
          text: axis.caption,
        },
        labels: {
          format: (axis.isPercent ? 'p' : 'n') + axis.scale,
          rotation: 'auto',
        },
      });
    }
    setValueAxis(axes);

    return axes;
  };

  //SINGLE PERIOD
  const _loadAxisDataSingle = (seriesHash) => {
    if (!chartData) return;

    let periodHash = {};

    for (let i = 0; i < chartData.length; i++) {
      let val = chartData[i];
      if (val.periodId !== selectedPeriod[periodIdField]) continue;
      let index = _categoryMap[val.nodeId];

      let series = seriesHash[val.measureId];
      if (series && index > -1) {
        let amount = val.amount / (series.sectionSeries.amountsIn || 1);
        series.chartSeries.data[index] = {
          value: amount,
          nodeId: val.nodeId,
          lookupRef: series.chartSeries.lookupRef,
          amount: amount,
        };
        _registerGridRecord(val, periodHash, amount);
      }
    }
  };

  //SINGLE PERIOD
  const _generateCategoriesSingle = (widgetInstance) => {
    _categoryMap = {};
    let categories = [];
    let objects = {};
    for (let i = 0; i < widgetInstance.nodes.length; i++) {
      let node = widgetInstance.nodes[i];
      let index = objects[node.objectId];
      if (index === undefined) {
        categories.push(node.name + (forLocalCurrency ? ' (' + node.currency + ')' : ''));
        _categoryMap[node.id] = i;
        objects[node.objectId] = i;
      } else {
        _categoryMap[node.id] = index;
      }
    }
    setCategories(categories);
    // categories need to be cleaned ???
    return categories;
  };

  //SINGLE PERIOD
  const _generateSeriesSingle = () => {
    let series = [];
    let seriesHash = {};

    let sectionSeries = setup.series[0];
    let measure = measures.find((item) => {
      return item.id.toString() === sectionSeries.measureId.toString();
    });
    if (measure) {
      let ser = _seriesBaseOptions(sectionSeries);
      ser.lookupRef = { measureId: sectionSeries.measureId, amountsIn: sectionSeries.amountsIn || 1 };

      seriesHash = {
        chartSeries: ser,
        sectionSeries: sectionSeries,
      };

      series.push(ser);
    }

    setup.series.forEach((sectionSeries) => {
      let measure = measures.find((item) => {
        return item.id.toString() === sectionSeries.measureId.toString();
      });

      if (measure) {
        let ser = _seriesBaseOptions(sectionSeries);
        let axs = setup.valueAxes.find((e) => e.id === sectionSeries.axis);
        ser.lookupRef = {
          //nodeId: node.id,
          measureId: sectionSeries.measureId,
          amountsIn: sectionSeries.amountsIn || 1,
          viewCashflows: sectionSeries.viewCashflows,
          scale: sectionSeries.scale,
          percentage: axs ? axs.isPercent : false,
        };

        seriesHash[measure.id] = {
          chartSeries: ser,
          sectionSeries: sectionSeries,
        };

        series.push(ser);
      }
    });

    _loadAxisDataSingle(seriesHash);

    _clearEmptySeries(series);

    setSeries(series);
  };

  //MULTI PERIOD
  const _generateCategories = () => {
    _categoryMap = {};
    let categories = [];

    for (let i = 0; i < periods.length; i++) {
      let period = periods[i];
      if (
        chartData.find((item) => {
          return item.periodId === period[periodIdField];
        })
      ) {
        _categoryMap[period[periodIdField]] = categories.length;
        categories.push(period.name);
      }
    }

    setCategories(categories);

    return categories;
  };

  //MULTI PERIOD
  const generateSeries = (widgetInstance) => {
    let seriesA = [];
    let seriesHash = {};
    let multipleMeasures = true;

    // nodes &&
    widgetInstance.nodes.forEach((node) => {
      for (let i = 0; i < setup.series.length; i++) {
        let sectionSeries = setup.series[i];

        let measure = measures.find((item) => {
          return item.id.toString() === sectionSeries.measureId.toString();
        });

        if (!measure) continue;

        let ser = _seriesBaseOptions(sectionSeries); // measure id + node identifier
        ser.name = node.name + (multipleMeasures ? ': ' + sectionSeries.name : '') + (forLocalCurrency ? ' (' + node.currency + ')' : '');
        let axs = setup.valueAxes.find((e) => e.id === sectionSeries.axis);
        ser.lookupRef = {
          nodeId: node.id,
          measureId: sectionSeries.measureId,
          amountsIn: sectionSeries.amountsIn || 1,
          viewCashflows: sectionSeries.viewCashflows,
          scale: sectionSeries.scale,
          percentage: axs ? axs.isPercent : false,
        };

        seriesHash[node.id + '_' + sectionSeries.measureId] = {
          chartSeries: ser,
          sectionSeries: sectionSeries,
        };

        seriesA.push(ser);
      }
    });

    //MULTI PERIOD
    const _loadAxisData = (seriesHash) => {
      if (!chartData) {
        return;
      }

      let periodHash = {};

      for (let i = 0; i < chartData.length; i++) {
        let val = chartData[i];

        let index = _categoryMap[val.periodId];

        let series = seriesHash[val.nodeId + '_' + val.measureId];

        if (series && index > -1) {
          let amount = val.amount / (series.sectionSeries.amountsIn || 1);

          series.chartSeries.data[index] = { amount: amount, lookupRef: series.chartSeries.lookupRef };
          _registerGridRecord(val, periodHash, amount);
        }
      }
    };

    _loadAxisData(seriesHash);

    _clearEmptySeries(seriesA);

    setSeries(seriesA);
  };

  if (setup.singlePeriod) {
    _generateCategoriesSingle(widgetData);
    _generateSeriesSingle();
    _generateValueAxes(setup.valueAxes);
  } else {
    _generateCategories();
    generateSeries(widgetData);
    _generateValueAxes(setup.valueAxes);
  }
};

export default generateAxisChart;
